import request from '../utils/request'

/**
 * 管理员登录
 * @param params { username, password }
 * @returns {*|Promise<AxiosResponse<T>>}
 */
const login = params => request.httpPost('/public/login', params);

export default {
  login,
};
